{
  "tabs": {
    "chat": "Разговор",
    "reminders": "Потсетници",
    "calendar": "Календар",
    "settings": "Поставки"
  },
  "common": {
    "cancel": "Откажи",
    "save": "Зачувај",
    "confirm": "Потврди",
    "delete": "Избриши",
    "back": "Назад",
    "close": "Затвори",
    "edit": "Уреди",
    "search": "Пребарај",
    "all": "Сите",
    "loading": "Се вчитува...",
    "error": "Се случи грешка",
    "notFound": "Не е пронајдено",
    "tryAgain": "Обиди се повторно",
    "retry": "Обиди се",
    "undo": "Поништи",
    "pullToRefresh": "Повлечи за освежување",
    "justNow": "токму сега"
  },
  "auth": {
    "welcome": "Добредојдовте во FishMemory",
    "tagline": "Ваш WhatsApp асистент за потсетници, сега во вашиот џеб.",
    "subtitle": "Ваш WhatsApp асистент за потсетници, сега во вашиот џеб.",
    "phoneLabel": "Вашиот WhatsApp број",
    "phoneHint": "Ќе испратиме код за верификација преку WhatsApp",
    "invalidPhone": "Ве молиме внесете валиден телефонски број",
    "continue": "Продолжи",
    "enterPhone": "Внесете го вашиот WhatsApp број",
    "phonePlaceholder": "Телефонски број",
    "sendCode": "Испрати код",
    "verifyTitle": "Верификувајте го бројот",
    "otpSentTo": "6-цифрен код е испратен на {{phone}} преку WhatsApp",
    "enterFullCode": "Ве молиме внесете ги сите 6 цифри",
    "invalidOtp": "Невалиден код. Обидете се повторно.",
    "otpFailed": "Не успеа испраќањето на кодот. Обидете се повторно.",
    "otpResent": "Кодот е повторно испратен",
    "resendIn": "Повторно испрати за {{seconds}}с",
    "resendCode": "Повторно испрати код",
    "enterOtp": "Внесете го кодот испратен на вашиот WhatsApp",
    "verify": "Верификувај",
    "resend": "Повторно испрати код",
    "wrongNumber": "Погрешен број?",
    "backToPhone": "Назад на бројот",
    "editPhone": "Уреди телефонски број",
    "error": "Грешка",
    "setupTitle": "Ајде да поставиме",
    "setupSubtitle": "Секогаш можете да ги промените подоцна во Поставки",
    "namePlaceholder": "Вашето име",
    "letsGo": "Заврши поставување",
    "skipForNow": "Прескокни засега"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Напишете порака...",
    "inputPlaceholder": "Напишете порака...",
    "typing": "FishMemory пишува...",
    "online": "Онлајн",
    "connecting": "Се поврзува...",
    "reconnecting": "Повторно се поврзува...",
    "offline": "Офлајн",
    "empty": "Започнете разговор",
    "emptyHint": "Креирајте потсетници, проверете распоред или побарајте помош.",
    "emptyAction": "Испрати пример потсетник",
    "actions": "Акции во разговор",
    "keep": "Зачувај пораки",
    "clearTitle": "Исчисти разговор",
    "clearConfirm": "Дали сакате да ги избришете сите пораки од овој уред? Ова не може да се врати.",
    "clear": "Исчисти разговор",
    "optionSelected": "Избрано: {{label}}",
    "sendingSelection": "Се испраќа...",
    "connectionLost": "Повторно се поврзува..."
  },
  "reminders": {
    "title": "Мои потсетници",
    "active": "Активни",
    "today": "Денес",
    "thisWeek": "Оваа недела",
    "history": "Историја",
    "items": "елементи",
    "emptyTitle": "Сè уште нема потсетници",
    "emptySubtitle": "Креирајте од разговор и ќе се појави тука.",
    "emptyAction": "Отвори разговор",
    "filterActive": "Активни",
    "filterToday": "Денес",
    "filterWeek": "Оваа недела",
    "filterHistory": "Историја",
    "emptyState": "Сè уште нема потсетници. Започнете разговор!",
    "swipeDone": "Завршено",
    "swipeSnooze": "Одложи",
    "swipeDelete": "Избриши",
    "search": "Пребарај потсетници...",
    "upcoming": "Претстојни",
    "completed": "Завршени",
    "overdue": "Просечени",
    "tomorrow": "Утре",
    "synced": "Синхронизирано {{value}}",
    "swipeHint": "Повлечете потсетник за повеќе акции",
    "noResults": "Нема потсетници кои одговараат на пребарувањето",
    "noResultsHint": "Обидете се со друга клучна реч или исчистете пребарување",
    "deleteAllFailed": "Не успеа бришењето на сите потсетници"
  },
  "calendar": {
    "title": "Календар",
    "today": "Денес",
    "tomorrow": "Утре",
    "completed": "завршено",
    "noEvents": "Нема закажани настани",
    "noEventsSubtitle": "Изберете датум за да ги видите потсетниците и настаните од календарот.",
    "googleEvent": "Google Calendar",
    "legendActive": "Активни",
    "legendRecurring": "Повторувачки",
    "legendDone": "Завршени",
    "legendGoogle": "Google",
    "previousMonth": "Претходен месец",
    "nextMonth": "Следен месец",
    "previousYear": "Претходна година",
    "nextYear": "Следна година",
    "goToToday": "Оди на денес",
    "all": "Сите",
    "active": "Активни",
    "done": "Завршени",
    "paused": "Пауза"
  },
  "settings": {
    "title": "Поставки",
    "profile": "Профил",
    "name": "Име за прикажување",
    "enterName": "Внесете име",
    "language": "Јазик",
    "uiLanguage": "Јазик на апликацијата",
    "uiLanguageHelp": "Го менува јазикот на интерфејсот, ознаките во календарот и насоката на распоредот само на овој уред.",
    "serverLanguage": "Јазик на разговор",
    "serverLanguageHelp": "Го менува јазикот што го користи серверот за одговори и пораки за потсетници за вашиот акаунт.",
    "timezone": "Временска зона",
    "currentTimezone": "Тековна временска зона",
    "timezoneHelp": "Сите времиња на потсетници се прикажуваат според оваа временска зона.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Зачувај временска зона",
    "timezoneSaved": "Временската зона е ажурирана",
    "detect": "Откриј",
    "detectFailed": "Не можеше да се открие временската зона",
    "autoDetect": "Автоматски откриј од GPS",
    "notifications": "Известувања",
    "notificationsHelp": "Потсетниците за повторување контролираат повторени известувања по доставување на потсетникот. Дозволите за известувања на уредот се управуваат во поставките на телефонот.",
    "pushEnabled": "Push известувања",
    "autoDoneOnFire": "Автоматски означи како завршено кога ќе се активира",
    "autoDoneOnFireDesc": "Кога е исклучено, потсетниците остануваат активни додека не ги означите како завршени.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Поврзано",
    "googleDisconnected": "Не е поврзано",
    "googleConnectedHelp": "Новите потсетници може автоматски да се синхронизираат со вашиот календар.",
    "googleDisconnectedHelp": "Поврзете Google Calendar за да ги усогласите потсетниците и настаните.",
    "googleConnectFailed": "Не успеа поврзувањето на Google Calendar",
    "connected": "Поврзано",
    "disconnected": "Не е поврзано",
    "connect": "Поврзи",
    "disconnect": "Прекъсни",
    "autoSync": "Автоматска синхронизација на нови потсетници",
    "autosync": "Автоматска синхронизација на нови потсетници",
    "subscription": "Претплата",
    "trialUsed": "Проба: {{used}}/{{total}} искористено",
    "trialStatus": "Проба достапна",
    "activeStatus": "Активна претплата",
    "expiredStatus": "Претплатата истече",
    "unsubscribedStatus": "Не сте претплатени",
    "about": "За",
    "version": "Верзија",
    "logout": "Одјави се",
    "logoutTitle": "Одјави се",
    "logoutConfirm": "Дали сте сигурни дека сакате да се одјавите?",
    "noName": "Нема внесено име",
    "serverConnection": "Поврзување со сервер",
    "serverUrl": "URL на серверот",
    "serverEdit": "Уреди",
    "saveReconnect": "Зачувај и повторно поврзи",
    "resetDefault": "Врати на стандардно",
    "invalidServerUrlTitle": "Невалиден URL на серверот",
    "invalidServerUrlMessage": "Внесете валиден http или https URL на сервер, на пример https://example.com",
    "uiLanguageChangeFailed": "Не успеа промената на јазикот на апликацијата. Обидете се повторно.",
    "serverLanguageChangeFailed": "Не успеа промената на јазикот на разговорот. Обидете се повторно.",
    "timezoneChangeFailed": "Не успеа промената на временската зона. Обидете се повторно.",
    "autoSyncChangeFailed": "Не успеа ажурирањето на автоматската синхронизација. Обидете се повторно.",
    "nameChangeFailed": "Не успеа ажурирањето на името за прикажување. Обидете се повторно.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Детали за потсетникот",
    "editTime": "Уреди време",
    "rename": "Преименувај",
    "snooze": "Одложи",
    "snooze15": "Одложи 15 минути",
    "pause": "Пауза",
    "pauseReminder": "Пауза на потсетникот",
    "resume": "Продолжи",
    "resumeReminder": "Продолжи потсетник",
    "skip": "Прескокни следно",
    "skipOccurrence": "Прескокни ова појавување",
    "syncGoogle": "Синхронизирај со Google",
    "delete": "Избриши",
    "deleteTitle": "Избриши потсетник",
    "deleteConfirm": "Овој потсетник ќе биде трајно избришан.",
    "deleteRecurringTitle": "Избриши повторувачки потсетник",
    "deleteRecurringMessage": "Дали сакате да го прескокнете ова појавување или да ја избришете целата серија?",
    "deleteThisOccurrence": "Прескокни ова појавување",
    "deleteEntireSeries": "Избриши цела серија",
    "done": "Завршено",
    "markDone": "Означи како завршено",
    "undo": "Врати",
    "undoPrompt": "Потребно ви е повторно активно? Вратете го сега.",
    "recurring": "Повторувачки",
    "nextRun": "Следно извршување",
    "oneTime": "Еднократно",
    "pending": "Во очекување",
    "sent": "Испратено",
    "paused": "Пауза",
    "active": "Активно",
    "snoozed": "Одложено",
    "localTime": "Прикажано во вашето локално време",
    "recurrence": "Повторување",
    "created": "Креирано",
    "tags": "Ознаки",
    "fireCount": "Број на активирања",
    "actions": "Акции",
    "none": "Нема",
    "snoozeFailed": "Не успе одложувањето на потсетникот",
    "pauseFailed": "Не успе паузирањето на потсетникот",
    "resumeFailed": "Не успе продолжувањето на потсетникот",
    "skipFailed": "Не успе прескокнувањето на потсетникот",
    "doneFailed": "Не успе означувањето на потсетникот како завршен",
    "undoFailed": "Не успе враќањето на статусот на потсетникот",
    "deleteFailed": "Не успе бришењето на потсетникот",
    "rescheduleTitle": "Промени термин?",
    "rescheduleMsg": "Овој потсетник е просечен. Дали сакате да го промените термин?",
    "reschedule15": "За 15 минути",
    "reschedule60": "За 1 час",
    "keepOverdue": "Зачувај како што е"
  },
  "onboarding": {
    "slide1Title": "Добредојдовте во FishMemory",
    "slide1Sub": "Ваш личен асистент за потсетници — со поддршка од WhatsApp и направен за вашиот џеб.",
    "slide2Title": "Само разговарај природно",
    "slide2Sub": "Внесувај потсетници како што размислуваш: „Потсети ме да ѝ се јавам на мама утре во 15 часот“ — ние го решаваме остатокот.",
    "slide3Title": "Никогаш не пропуштај ништо",
    "slide3Sub": "Добиј навремени известувања, организирај со ознаки и следи сè што е важно.",
    "getStarted": "Започни",
    "next": "Следно",
    "firstReminderTitle": "Креирај го првиот потсетник!",
    "firstReminderHint": "Обиди се да внесеш нешто како:",
    "firstReminderExample": "Потсети ме да пијам вода утре во 9 часот",
    "gotIt": "Разбрав!",
    "notifRationaleTitle": "Биди навреме",
    "notifRationaleBody": "FishMemory треба известувања за да те потсети навреме. Ќе добиваш известувања само за потсетниците што ги креираш.",
    "notifRationaleAllow": "Овозможи известувања",
    "notifRationaleLater": "Можеби подоцна",
    "swipeHint": "Повлечи десно за брзи акции →",
    "calendarDragHint": "Влечи за проширување ↕"
  }
}
